'use strict';

var wrapObjectMatcher = require('../internal/wrapObjectMatcher');

module.exports = {
  objectSome: wrapObjectMatcher('some'),
  objectFind: wrapObjectMatcher('find'),
  objectEvery: wrapObjectMatcher('every')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/enumerable/var/objectMatchers.js
// module id = 136
// module chunks = 1